'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import gtm from 'eco-design-reliance/gtm';
import EcoButton from 'eco-design/base/eco-button';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';

export default function Content({ id, data = {}, initIndex = 0, isEditStatus = false }: ContentServerProps) {
    const { label, title, desc, labelType, list = [] } = data;
    const prefixCls = 'index-tab-list-a';
    const prefixClsA = 'index-tab-list-a-box1';
    const prefixClsB = 'index-tab-list-a-box2';
    const [activeIndexA, setActiveIndexA] = useState(initIndex);
    const firstItemA = list[isEditStatus ? initIndex : activeIndexA] || {};
    const [itemsB, setItemsB] = useState(firstItemA.list2 || []);
    const recommended_title = list[activeIndexA]?.recommended_title || ''; //推荐标题
    const tabChangeA = (itemA: any, index: number) => {
        setActiveIndexA(index);
        setItemsB(itemA.list2 || []);

        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: title,
            button_name: itemA.tab_name,

            __btn_id1: `juzheng-tabs-item-${index}`,
            __btn_id2: itemA.tab_name,
            __btn_type: 'common',
        });
    };
    useEffect(() => {
        setItemsB(firstItemA.list2 || []);
    }, [data, firstItemA, firstItemA.list2]);

    return (
        <GloLayout className={`editor-index-tab-list-a`} id={id} data={data}>
            <div className="eco-content-v2 index-tab-list-a-info">
                {labelType === 'DIY' && label && <p className={`${prefixCls}-label`}>{label}</p>}
                {labelType === 'NO1' && (
                    <div className={`${prefixCls}-label default`}>
                        <span>Global</span>
                        <img src="https://websiteoss.ecoflow.com/upload/image/1764140591441/icon.png" draggable="false" />
                        <span>Portable Power Station in Sales*</span>
                    </div>
                )}
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <p className={`${prefixCls}-desc`}>{desc}</p>
            </div>

            <Swiper className={`${prefixCls}-tabs-list`} slidesPerView="auto" initialSlide={initIndex}>
                {list.map((itemA: any, index: number) => {
                    const itemClassesA = classNames({
                        [`${prefixCls}-tabs-item`]: true,
                        [`${prefixCls}-tabs-item-active`]: activeIndexA === index,
                    });
                    return (
                        <SwiperSlide
                            key={index}
                            className={`${itemClassesA} GtmModuleData-btn-common juzheng-tabs-item-${index}`}
                            data-btn-id={itemA.tab_anem}
                            onClick={() => tabChangeA(itemA, index)}
                        >
                            {itemA.tab_name}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div className="eco-content-v2">
                <div className={prefixClsA}>
                    <div
                        className={classNames({
                            [`${prefixClsA}-item`]: true,
                            [`${prefixClsA}-theme-${firstItemA.theme}`]: firstItemA.theme,
                        })}
                    >
                        <div
                            className={`${prefixClsA}-item-img`}
                            onClick={() => {
                                if (firstItemA?.lHref) {
                                    window.open(firstItemA.lHref, '_blank');
                                }
                            }}
                        >
                            <EcoImgVideo isVideo={firstItemA?.isVideo} pc={firstItemA?.pc} h5={firstItemA?.h5} />
                        </div>
                        <div className={`${prefixClsA}-item-msg`}>
                            <div className={`${prefixClsA}-item-info`}>
                                {firstItemA?.label && <div className={`${prefixClsA}-item-label`}>{firstItemA?.label}</div>}
                                {firstItemA?.title && <div className={`${prefixClsA}-item-title`}>{firstItemA?.title}</div>}
                                {firstItemA?.desc && <div className={`${prefixClsA}-item-desc`}>{firstItemA?.desc}</div>}
                            </div>
                            <div
                                className={`${prefixClsA}-item-box-btn`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <EcoButton
                                    className={`juzhen-content-btn-l-${activeIndexA} GtmModuleData-btn-href`}
                                    lTheme={firstItemA?.theme}
                                    lType="text"
                                    lHref={firstItemA?.lHref}
                                    lChildren={firstItemA?.lBtnContent}
                                    lIsWithRightArrow={true}
                                    lDataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'click_help_me_choose',
                                        product_name: firstItemA?.title,

                                        __btn_id1: `juzhen-content-btn-l-${activeIndexA + 1}`,
                                        __btn_id2: firstItemA?.lHref,
                                        __btn_type: 'href',
                                    }}
                                />
                                <EcoButton
                                    className={`juzhen-content-btn-r-${activeIndexA} GtmModuleData-btn-href`}
                                    lTheme={firstItemA?.theme}
                                    lType="text"
                                    lHref={firstItemA?.rHref}
                                    lChildren={firstItemA?.rBtnContent}
                                    lIsWithRightArrow={true}
                                    lDataLayer={{
                                        ...getUrlGtm(firstItemA.rHref, {
                                            button_name: firstItemA?.rBtnContent,
                                            product_name: firstItemA?.title,
                                            list_name: title,
                                        }),
                                        position: `Homepage_middlebanner_2_${activeIndexA + 1}`,

                                        __btn_id1: `juzhen-content-btn-r-${activeIndexA}`,
                                        __btn_id2: firstItemA?.rHref,
                                        __btn_type: 'href',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`eco-content-v2`}>
                <div className={`${prefixClsB}-title`}>{recommended_title}</div>
            </div>

            <ul className={`${prefixClsB}-list length-${itemsB.length}`}>
                {itemsB.map((itemA: any, index: number) => {
                    if (!itemA) {
                        return null;
                    }
                    const { label, title, desc, theme = 'white' } = itemA;
                    const gtmObj = {
                        event: 'uaEvent',
                        event_name: 'select_product',
                        list_name: recommended_title,
                        product_name: title,
                        button_name: itemA.lBtnContent,
                        position: `Homepage_ProductList_1_leftBtn`,

                        __btn_id1: `juzheng-more-${activeIndexA}-${index}`,
                        __btn_id2: itemA.lHref,
                        __btn_type: 'href',
                    };
                    return (
                        <li key={index} className={`${prefixClsB}-item length-${itemsB.length}`}>
                            <div
                                className={`${prefixClsB}-item-img`}
                                onClick={() => {
                                    if (itemA.lHref) {
                                        window.open(itemA.lHref, '_blank');
                                        gtm.push(gtmObj);
                                    }
                                }}
                            >
                                <EcoImgVideo isVideo={itemA.isVideo} pc={itemA.pc} h5={itemA.h5} />
                            </div>
                            <div className={`${prefixClsB}-item-msg`}>
                                <div className={`${prefixClsB}-item-info`}>
                                    {label && <div className={`${prefixClsB}-item-label`}>{label}</div>}
                                    {title && <div className={`${prefixClsB}-item-title`}>{title}</div>}
                                    {desc && <div className={`${prefixClsB}-item-desc`}>{desc}</div>}
                                </div>
                                <div className={`${prefixClsB}-item-box-btn`}>
                                    <EcoButton
                                        className={`${prefixClsB}-item-box-btn-item juzheng-more-${activeIndexA}-${index} GtmModuleData-btn-href`}
                                        lTheme="black"
                                        lType="filled"
                                        lRadius="ellipse"
                                        lHref={itemA.lHref}
                                        lChildren={itemA.lBtnContent}
                                        lDataLayer={gtmObj}
                                    />
                                    <EcoButton
                                        className={`${prefixClsB}-item-box-btn-item juzheng-buy-${activeIndexA}-${index} GtmModuleData-btn-href`}
                                        lTheme="black"
                                        lType="outlined"
                                        lRadius="ellipse"
                                        lHref={itemA.rHref}
                                        lChildren={itemA.rBtnContent}
                                        lDataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: title,
                                            position: `Homepage_ProductList_1_rightBtn`,
                                            display_type: 'none',
                                            module_referral: 'none',
                                            jump_module: 'none',
                                            url: itemA.rHref,

                                            __btn_id1: `juzheng-buy-${activeIndexA}-${index}`,
                                            __btn_id2: itemA.rHref,
                                            __btn_type: 'href',
                                        }}
                                    />
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </GloLayout>
    );
}
